var publicPath = __webpack_public_path__;
                    module.exports = {
                        symbol: publicPath + 'sprite.svg#icon-secure-payment',
                        view: publicPath + 'sprite.svg#view-icon-secure-payment',
                        viewBox: '0 0 24 22',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };